import { RefObject, useEffect } from 'react';

import { useCoreDispatch } from '../store/CoreStore';
import { configActions } from '../store/slices/config/slice';
import { debounce } from '../utils/debounce';

export const usePlayAreaSetter = (playArea: RefObject<HTMLElement>): void => {
  const dispatch = useCoreDispatch();

  useEffect(() => {
    const updateDimensions = debounce(() => {
      const boundingRect = playArea.current?.getBoundingClientRect();
      if (boundingRect) {
        const playAreaSize = {
          x: boundingRect.x,
          y: boundingRect.y,
          width: boundingRect.width,
          height: boundingRect.height,
          top: boundingRect.top,
          bottom: boundingRect.bottom,
          left: boundingRect.left,
          right: boundingRect.right,
          bottomOffset: window.innerHeight - boundingRect.y,
        };

        dispatch(configActions.setPlayAreaDimensions(playAreaSize));
      }
    }, 100);

    window.addEventListener('resize', updateDimensions, { passive: true });
    updateDimensions();
    return (): void => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, [dispatch, playArea]);
};
